import { ContentCopy, Upload } from '@mui/icons-material';
import {
    Box,
    Button,
    Container,
    Dialog,
    DialogActions,
    DialogContent,
    IconButton,
    List,
    ListItem,
    ListItemText,
    styled,
} from '@mui/material';
import { ArrowLeftIcon } from '@mui/x-date-pickers';
import { Stack } from '@sanity/ui';
import LogoDropZone from 'components/controls/logo-drop-zone';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { useAddDocumentMutation, useLazyGetDocumentQuery } from 'services/documents';
import { Document } from 'services/documents/types/dtos';
import { dataURLtoFile } from 'utils/file-helpers';

const ControlsWrapper = styled(Box)({
    display: 'flex',

    alignItems: 'center',
    marginBottom: '5px',
    padding: '1rem',
});

const StudioButton = styled(Button)({
    maxWidth: 150,
    height: '2rem',
    backgroundColor: 'transparent',
    color: 'black',
    border: '1px solid black',
    ':hover': {
        backgroundColor: 'transparent',
    },
});

// Adds markup and invokes renderDefault()
export function MyEnhancedNavbar(props) {
    const navigate = useNavigate();
    const [logo, setLogo] = useState<string | undefined>();
    const [documentUrl, setDocumentUrl] = useState<Document>();

    const [open, setOpen] = useState(false);

    const [addDocument, { isLoading }] = useAddDocumentMutation();
    const [getDocument] = useLazyGetDocumentQuery();

    const handleLogoChange = async (newLogo: string) => {
        setLogo(newLogo);
    };

    const handleUploadDocument = async () => {
        try {
            const documentId = (await addDocument(dataURLtoFile(logo)).unwrap()).documentId;

            const document = await getDocument(documentId).unwrap();

            setDocumentUrl(document);
        } catch (error) {
            console.error('Upload failed:', error);
        }
    };

    const handleCopy = (url: string) => {
        navigator.clipboard.writeText(url);
    };

    const handleGoBack = () => {
        navigate('/websites');
    };

    return (
        <Stack>
            <ControlsWrapper>
                <StudioButton onClick={handleGoBack} variant="text" color="primary" sx={{ marginRight: 'auto' }}>
                    <ArrowLeftIcon /> Go back
                </StudioButton>
                <StudioButton
                    variant="contained"
                    color="primary"
                    onClick={() => setOpen(true)}
                    fullWidth
                    startIcon={<Upload />}
                    sx={{ maxWidth: 150 }}
                >
                    Upload
                </StudioButton>
            </ControlsWrapper>
            <Dialog style={{ zIndex: 9999 }} open={open} onClose={() => setOpen(false)} maxWidth="sm" fullWidth>
                <DialogContent>
                    <LogoDropZone logo={logo} onChange={handleLogoChange} />
                    {isLoading && <p>Učitavanje...</p>}
                </DialogContent>
                <DialogActions>
                    <Container>
                        {documentUrl?.filePaths && Object.entries(JSON.parse(documentUrl?.filePaths)).length > 0 && (
                            <List>
                                {Object.entries(JSON.parse(documentUrl?.filePaths)).map(([key, url]) => (
                                    <ListItem key={key} sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                        <ListItemText primary={`${key}: ${url}`} />
                                        <IconButton onClick={() => handleCopy(url as string)} edge="end">
                                            <ContentCopy />
                                        </IconButton>
                                    </ListItem>
                                ))}
                            </List>
                        )}
                        <Button onClick={handleUploadDocument} color="secondary">
                            Upload
                        </Button>
                    </Container>
                </DialogActions>
            </Dialog>
            <>{props.renderDefault(props)}</>
        </Stack>
    );
}
